import {$} from "../Frontend";
import {FrontendPage} from "../FrontendPage";

export class Ship extends FrontendPage {
    onReady() {
        $('.toggle-region-overlay').on('click', e => {
            const $ship = $(e.target).closest('.ship');
            $ship.find('.region-list').addClass('show');
        });

        $('.region-list').on('click', e => {
            $(e.target).closest('.region-list').removeClass('show');
            e.preventDefault();
        });

        $('#sort').on('input change', e => {
            $('#sort').closest('form').submit();
        });
    }

    runOnCurrentPage(): boolean {
        return $('.ship-list').length > 0;
    }
}
